import $ from "jquery";


class UrlBuilder {
    constructor(arrayQueryParams = []) {
        this.storedFilters = null;
        /* Parse available filter to variable */
        let urlFilters = this.getAllUrlParams();
         if(!!urlFilters){
             Object.entries(urlFilters).map((keyValue) => {
                 if(arrayQueryParams.includes(keyValue[0])){
                     urlFilters[keyValue[0]] = [...keyValue[1].split(",")];
                 }
             });
             this.storedFilters = urlFilters;
         }
    };

    getStoredFilters (){
        return this.storedFilters;
    }

    updateArrayBaseFilter (key, value, isArrayAble = true){
        console.log("update", key, value);
        /* Check any key exist in variable */
        if(!!this.storedFilters){
            /* Check key */
            const existKey = Object.keys(this.storedFilters).find(findKey => findKey === key);
            if(!!existKey){
                /* Check it is an isArrayAble element */
                if(isArrayAble){
                    /*## If array able element ##*/
                    /* Check value exist blow key */
                    const existValue = this.storedFilters[key].find(findValue  => findValue === value );
                    if(!!existValue){
                        /* If exist remove it */
                        const removedItems = this.storedFilters[key].filter(filterValue => filterValue !== value);
                        /* Check while remove has more item */
                        if(removedItems.length > 0){
                            /* If has replace */
                            this.storedFilters[key] = [...removedItems];
                        }else{
                            this.removeKey(key)
                        }
                    }else{
                        /* If not exist add it */
                        this.storedFilters[key] = [...this.storedFilters[key],value];
                    }
                }else{
                    /*## If NOT array able element ##*/
                    /* Check value is empty string */
                    if(value === ""){
                      this.removeKey(key)
                    }else{
                        this.storedFilters[key] = value;
                    }
                }

            }else{
                if(value !== ""){
                    /* Not exist current key in object then add key & value */
                    if(isArrayAble){
                        this.storedFilters[key] = [value];
                    }else{
                        // Todo check value empty
                        this.storedFilters[key] = value;
                    }
                }
            }
        }else{
            if(value !== ""){
                if(isArrayAble){
                    /* Add key and value*/
                    this.storedFilters = {
                        [key] : [value]
                    }
                }else{
                    /* Add key and value*/
                    // Todo check value empty
                    this.storedFilters = {
                        [key] : value
                    }
                }
            }

        }
        /* Rebuild */
        this.rebuild()
    }

    getAllUrlParams() {
        // get query string from url (optional) or window
        let queryString = window.location.search.slice(1);

        queryString = decodeURIComponent(queryString);

        // we'll store the parameters here

        // if query string exists
        if (queryString) {
            // split our query string into its component parts
            let arr = queryString.split('&');


            return arr.reduce((carry, arrItem) => {


                // separate the keys and the values
                let a = arrItem.split('=');

                // set parameter name and value (use 'true' if empty)
                let paramName = a[0].toString();
                let paramValue = (typeof a[1] === 'undefined') ? true : a[1];

                // (optional) keep case consistent
                //paramName = paramName.toLowerCase();
                //if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

                // if it doesn't exist, create property
                carry[paramName] = paramValue;

                return carry;
            }, {});

        }

        return {};
    }



    removeKey (key){
        /* Remove key */
        delete this.storedFilters[key];
        /* Check has any more key at variable */
        if(Object.keys(this.storedFilters).length === 0){
            this.storedFilters = null;
        }
    }

    rebuild () {
        /* Build url tag */
        let url = "/buy";

        /* Check has any storedFilters */
        if(!!this.storedFilters && Object.keys(this.storedFilters).length > 0){
            url += "?";
            Object.keys(this.storedFilters).map((key) => {

                    const index = Object.keys(this.storedFilters).indexOf(key);
                    const startChar = index !== 0 && index !== Object.keys(this.storedFilters).length ? "&" : "";
                    /*if(key === "page"){
                        this.storedFilters[key] = 1;
                    }*/
                    url += startChar+key+"="+(Array.isArray(this.storedFilters[key]) ? encodeURIComponent(this.storedFilters[key].join(",")) : encodeURIComponent(this.storedFilters[key]));

            })
        }
        /* History push new url*/
        window.history.pushState({path: url},'',url);

    };

}


export default  UrlBuilder;
